import profile from './profile';
import type from './type';

const state = {};

const getters = {};

const mutations = {};

const actions = {};

const modules = {
    profile,
    type,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules,
};
